import { motion } from "framer-motion";

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="font-display text-2xl font-semibold text-zinc-900">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Card({ children, className = "", testid, hover = false }) {
  return (
    <div
      data-testid={testid}
      className={`bg-white border border-zinc-200 rounded-xl shadow-card ${
        hover ? "transition-all duration-200 hover:shadow-lift hover:-translate-y-0.5" : ""
      } ${className}`}
    >
      {children}
    </div>
  );
}

// Shared table styling for consistent dashboard tables
export const TH_CLASS =
  "px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-zinc-400";
export const TD_CLASS = "px-4 py-3 text-sm text-zinc-700 tnum";
export const TABLE_WRAP_CLASS = "overflow-x-auto";
export const TABLE_ROW_CLASS = "border-t border-zinc-100 hover:bg-zinc-50 transition-colors";

export function Stat({ label, value, sub, accent, testid, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay }}
      data-testid={testid}
      className="bg-white border border-zinc-200 rounded-xl p-5 shadow-sm shadow-zinc-200/40"
    >
      <div className="text-xs font-semibold uppercase tracking-[0.1em] text-zinc-400">{label}</div>
      <div className={`mt-2 font-display text-2xl font-semibold tnum ${accent || "text-zinc-900"}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-zinc-500">{sub}</div>}
    </motion.div>
  );
}

const LEVELS = {
  danger: "bg-red-50 text-red-700 border-red-200",
  warning: "bg-orange-50 text-orange-700 border-orange-200",
  info: "bg-amber-50 text-amber-700 border-amber-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  muted: "bg-zinc-50 text-zinc-600 border-zinc-200",
};

export function Badge({ level = "muted", children }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${LEVELS[level]}`}>
      {children}
    </span>
  );
}

export function Loading({ label = "Loading…" }) {
  return <div className="py-20 text-center text-zinc-400 text-sm">{label}</div>;
}

export const CHART_GRID = "#f4f4f5";
